
  import { SmartBannerConfig } from './index'
  export const config: SmartBannerConfig = {
    festivalName: 'Japan Event by CGC',
    appTitle: 'Japan Event CGC',
    appStoreId: '0',
    appleStoreUrl: 'null',
    googleStoreUrl: 'null',
    appIconUrl: 'https://static.japaneventcgc.chapi.to/app-icon.jpeg',
  }
